module.exports = __webpack_public_path__ + "static/media/guvilogo.08cb9079.png";